import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Select from 'react-select';

import {
  accountId,
  focusAfterTimeout,
} from '../../util';

import { getIcon } from '../../util/icons';

import moment from 'moment';

import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

import {
  linkSalesforceDeal
} from '../../actions/integrations/salesforce';

class LinkSalesforceDealModal extends Component{

  state = {
    saving: false,
    error: null,
    selectedDealId: null,
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.editingDeal){
      this.setState({
        deal: nextProps.editingDeal,
      });
    }
  }

  clearError(){
    this.setState({
      error: null,
    });
  }

  linkSalesforceDeal(){

    if(this.state.saving){
      return;
    }

    this.setState({
      saving: true
    });

    linkSalesforceDeal(this.props.linkingDealId, this.state.selectedDealId, this.afterLink.bind(this));
  }

  afterLink(res){
    if(!res.success){
      this.setState({
        saving: false,
        error: res.error
      });
    }
    else{
      this.setState({
        saving: false
      }, () => {
        this.props.afterLink(res.data);
      });
    }
  }

  renderFormMessage(){
    if(this.state.error){
      return <div className="form-message error">{this.state.error}</div>;
    }
    else{
      return null;
    }
  }

  getOptionForValue(options, value){
    return _.find(options, option => {
      return option.value === value;
    });
  }

  renderLinkDealForm(){

    const {
      selectedDealId
    } = this.state;

    const { viewingUser } = this.props;

    const deals = this.props.deals;

    const salesforceDeals = _.filter(this.props.deals, { source: 'salesforce' });

    const blankSalesforceDeals = _.filter(salesforceDeals, deal => {
      //only SF deals which haven't had items added to them...
      return _.size(deal.funnelTasks) + _.size(deal.imperativeSummaries) + _.size(deal.imperativeTasks) === 0;
    });

    const salesforceDealsOptions = _.map(blankSalesforceDeals, deal => {
      return {
        value: deal._id,
        label: deal.name
      }
    });

    return(
      <form className="velocity-form">
        <h2>Link to Salesforce...</h2>
        <p className="subheading">This deal will be deleted and it's progress will be transferred over to the selected Salesforce deal...</p>
        <p><small>Note that the Name, Status, Estimated Close Date, and Estimated Value of this deal will all be replaced by the equivalent values in salesforce.{/* Also, any progress made so far on the salesforce deal to be merged will be replaced with this deal's progress.*/}</small></p>
        {this.renderFormMessage()}
        <div className="form-group">
          <Select
            classNamePrefix={'react-select'}
            className='react-select-container fs-block'
            value={this.getOptionForValue(salesforceDealsOptions, selectedDealId)}
            options={salesforceDealsOptions}
            onChange={(option) => { this.setState({ selectedDealId: option.value }); }}
            isSearchable={true}
          />
        </div>
      </form>
    )
  }

  renderActions(){
    const {
      saving
    } = this.state;

    return (
      <React.Fragment>
        <button className="button salesforce-button" onClick={this.linkSalesforceDeal.bind(this)} disabled={saving}>{getIcon('salesforce-outline')}{saving ? 'Syncing...' : 'Link Deal'}</button>
        <button className="button grey-button" onClick={this.props.hide}>Cancel</button>
      </React.Fragment>
    )
  }

  render(){

    if(!this.props.visible){
      return null;
    }

    const { saving, selectedDealId } = this.state;

    return (
      <div className={`modal update-deal`}>
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.hide}>X</div>
          <div className="modal-content">
            {this.renderLinkDealForm()}
          </div>
          <div className="modal-actions">
            {!selectedDealId && !saving &&
              <button className="button primary" onClick={this.props.hide}>Done</button>
            }
            {(selectedDealId || saving) && this.renderActions()}
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {

  }
}

export default connect(mapStateToProps, {  })(LinkSalesforceDealModal);



// WEBPACK FOOTER //
// ./src/components/modals/linkSalesforceDeal.js